import { ActivityVariable } from "../types/activity";
import { formatMeasurementWithUnit } from "./unitUtils";

/** Display a session target value, e.g. "13.10 s" or "1:08.90" for Time. */
export function formatTargetValue(variable: {
  name: string;
  goal: number;
  unit?: string;
}): string {
  return formatMeasurementWithUnit(variable.goal, variable.unit, variable.name);
}

/** Display a measured variable, e.g. "13.12 s". */
export function formatResultVariable(variable: ActivityVariable): string {
  return formatMeasurementWithUnit(
    variable.measurement,
    variable.unit,
    variable.name,
  );
}
